import { baseDobbyTheme } from "../theme/dobbyTheme";
import { createTheme } from "@mui/material/styles";

// Create a custom theme specifically for admin pages with condensed styling
export const adminTheme = createTheme(baseDobbyTheme, {});
